var _path, _circle, _path2, _path3, _circle2, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionViewInArColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z",
    fill: "url(#paint0_linear_2829_1995)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5,
    fill: "url(#paint1_radial_2829_1995)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 10.125C12 10.8154 11.4404 11.375 10.75 11.375C10.0596 11.375 9.5 10.8154 9.5 10.125C9.5 9.43464 10.0596 8.875 10.75 8.875C11.4404 8.875 12 9.43464 12 10.125Z",
    fill: "#1D3547"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.75 11.375C15.75 11.8928 15.3303 12.3125 14.8125 12.3125C14.2947 12.3125 13.875 11.8928 13.875 11.375C13.875 10.8572 14.2947 10.4375 14.8125 10.4375C15.3303 10.4375 15.75 10.8572 15.75 11.375Z",
    fill: "#1D3547"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 13.875,
    cy: 15.125,
    r: 0.625,
    fill: "#1D3547"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15V18H9V20H6C4.89543 20 4 19.1046 4 18V15H6Z",
    fill: "#FEC14B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V18C20 19.1046 19.1046 20 18 20H15V18H18V15H20Z",
    fill: "#FEC14B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6H6V9H4V6C4 4.89543 4.89543 4 6 4H9V6Z",
    fill: "#FEC14B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4C19.1046 4 20 4.89543 20 6V9H18V6H15V4H18Z",
    fill: "#FEC14B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2829_1995",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399675,
    stopColor: "#25282D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5042EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2829_1995",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.75 9.5) rotate(54.4623) scale(10.7529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613598,
    stopColor: "#BDCEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FCFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980769,
    stopColor: "#FCFBFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionViewInArColored);
export default __webpack_public_path__ + "static/media/ic_action_view_in_ar_colored.08958f4f4de84d267c6d8a6e353c19f8.svg";
export { ForwardRef as ReactComponent };